import { Dispatch } from "react"
import { QuestionnaireResponsePair } from "../questionnaire/models"

export interface TextAreaCache {
  [sectionId: string]: Record<string, string | null>
}

export enum TextAreaStateActionType {
  Change = "change",
  Undo = "undo",
  Reset = "reset",
}

type AllResponsePairKeys = keyof QuestionnaireResponsePair
export type EditResponsePairKey = Extract<
  AllResponsePairKeys,
  "question" | "response"
>

export interface TextAreaStateAction {
  type: TextAreaStateActionType
  payload: ChangeActionPayload | ResetActionPayload
}

export interface ExcelCellInfo {
  cellAddress?: string
  sheetName?: string
}

export interface ChangeActionPayload {
  sectionId: string
  responsePairId: string
  text: string
  excel?: ExcelCellInfo
}

export interface ResetActionPayload {
  state: TextAreaState
}

export type TextAreaStateDispatch = Dispatch<TextAreaStateAction>

export interface TextAreaCount {
  total: number
  sections: Record<string, number>
}

export interface TextAreaState {
  texts: TextAreaCache
  textsCount: TextAreaCount
}

export function isChangeActionPayload(
  payload: ChangeActionPayload | ResetActionPayload,
): payload is ChangeActionPayload {
  try {
    return (
      (payload as ChangeActionPayload).sectionId !== undefined &&
      (payload as ChangeActionPayload).responsePairId !== undefined &&
      (payload as ChangeActionPayload).text !== undefined
    )
  } catch {
    return false
  }
}

export function isResetActionPayload(
  payload: ChangeActionPayload | ResetActionPayload,
): payload is ResetActionPayload {
  try {
    return (payload as ResetActionPayload).state !== undefined
  } catch {
    return false
  }
}
